/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { SystemFolderType } from '../../constants/fsi'

export const DOCUMENTS_VIEW_TYPE = {
  regulatedContent: SystemFolderType.REGULATED_CONTENT,
  systemDocuments: SystemFolderType.SYSTEM_DOCUMENTS,
  propertySearch: 'property-search',
  favorites: 'favorites',
  recent: 'recent',
  periodicReviewUpcoming: 'periodicReviewUpcoming'
} as const

export type DocumentsViewType = (typeof DOCUMENTS_VIEW_TYPE)[keyof typeof DOCUMENTS_VIEW_TYPE]

export interface PageConfiguration {
  title: string
  showActionMenu: boolean
  showFilter: boolean
  showBreadcrumbs: boolean
  updatePageUrlParam: boolean
  isAbstract: boolean
  isPropertySearch?: boolean
  isReportView?: boolean
  isPeriodicReviewView?: boolean
  showGridViewTrigger?: boolean
  loaded: boolean
  loadDataFn: ((queryParams: any, filter?: any) => Promise<any>) | null
}

export interface FolderDetails {
  id?: number
  name?: string
  path?: any[]
  folderPathText?: string
  [key: string]: any
}
